export default "__VITE_ASSET__BMZuQGGr__"